function getConfig(env) {
  // Little trick to work around react-create-app's shortcomings.
  env = env || process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV;
  return require(`../config/${env}.js`);
};

export default getConfig;



// WEBPACK FOOTER //
// ./src/config/index.js